import { FormMode } from '../../controls/common/form-mode';
import { ViewFormContext } from './view-form-context';

export class ViewDetailContext {
    /**
     * Indique si le formulaire est en mode édition (true) ou en mode consultation (false).
     */
    private _formMode: FormMode = FormMode.Reading;

    public get formMode(): FormMode {
        return this._formMode;
    }

    public set formMode(value: FormMode) {
        this._formMode = value;
        this.viewContext.mode = value;
    }

    public editedViewId: number = null;

    public viewContext: ViewFormContext = new ViewFormContext();
}
